module.exports = __webpack_public_path__ + "static/media/667e3712186e4bac44066e086521b46a.667e3712.webp";